var _ = require('underscore');
var TorsoBehavior = require('backbone-torso/modules/Behavior');

/**
 * This behavior adds customizable validation to demographics related views
 *
 * @class DemographicsValidationBehavior
 * @constructor
 */
module.exports = TorsoBehavior.extend({

  mixin: {
    /**
     * Check the demographics configuration to see if there are any missing or invalid properties
     * @method validate
     * @returns {boolean} if the context is valid or not
     */
    validate: function () {
      var configs = this.view.get('context.config');
      var isValid = true;
      if (!configs) {
        return false;
      }
      _.each(configs, function (config) {
        if (config.missing || config.invalid) {
          isValid = false;
        }
      });
      return isValid;
    },

    /**
     * @method hasRequiredFields
     * @returns {boolean} whether the config has any required fields
     */
    hasRequiredFields: function() {
      var config = this.view._config;
      var configRequiredValues = _.flatten(
        _.map(config, function(config) {
          return _.pluck(config, 'validationConfiguration');
        })
      );
      return  _.any(configRequiredValues, function(fieldConfig) {
        return fieldConfig && fieldConfig.required;
      });
    }
  }
});
